/* oxlint-disable */
import { User } from "@lemmonhq/types";
import * as Sentry from "@sentry/vue";
import type Amplititude from "@amplitude/analytics-browser";
import type { Mixpanel } from "mixpanel-browser";
import type { PostHog } from "posthog-js";

export const getAmplitude = () => {
  const amplitude = (window as any)["amplitude"] as typeof Amplititude;
  return amplitude;
};
export const getMixpanel = () => {
  const amplitude = (window as any)["mixpanel"] as Mixpanel;
  return amplitude;
};
export const getPosthog = () => {
  const posthog = (window as any)["posthog"] as PostHog;
  return posthog;
};

export const instrumentation = {
  identify: (user: User) => {
    console.info("called identify", user);
    try {
      const sentryAttrs = {
        username: `${user.profile.name} | ${user.restaurant.name}`,
        id: user.id.toString(),
        shopName: user.restaurant.name,
        shopId: user.restaurant.id,
      };
      try {
        console.info("sentryAttrs", sentryAttrs);
        Sentry.setUser(sentryAttrs);
      } catch (e) {
        //        console.error(e);
      }

      // GE (Geneva) restaurants are exempt from client-side tracking.
      const trackingEnabled = user.restaurant?.jurisdiction !== "GE";

      try {
        const amplitude = getAmplitude();
        amplitude.setUserId(sentryAttrs.id + ` - ${sentryAttrs.username}`);
        const identifyEvent = new amplitude.Identify();
        identifyEvent.set("name", sentryAttrs.username);
        identifyEvent.set("shopId", sentryAttrs.shopId);
        amplitude.identify(identifyEvent);

        amplitude.setOptOut(!trackingEnabled);
      } catch (e) {
        //console.error(e);
      }

      //      try {
      //        const mixpanel = getMixpanel();
      //        mixpanel.identify(sentryAttrs.id);
      //        mixpanel.people.set({
      //          $name: sentryAttrs.username,
      //          shopName: sentryAttrs.shopName,
      //          shopId: sentryAttrs.shopId,
      //          // Add anything else about the user here
      //        });
      //      } catch (e) {
      //        console.error(e);
      //      }

      try {
        const posthog = getPosthog();
        posthog.identify(sentryAttrs.id, {
          name: sentryAttrs.username,
          shopName: sentryAttrs.shopName,
          shopId: sentryAttrs.shopId,
        });
        posthog.set_config({
          autocapture: trackingEnabled
            ? { dom_event_allowlist: ["click", "submit"] }
            : false,
        });
        if (trackingEnabled) {
          posthog.startSessionRecording();
        } else {
          posthog.stopSessionRecording();
        }
      } catch (e) {
        //console.error(e);
      }
    } catch (e) {
      //console.error(e);
      //
    }
  },
  trackRevenue: (orderId: number, price: number, props?: any) => {
    try {
      const amplitude = getAmplitude();
      const event = new amplitude.Revenue()
        .setProductId(orderId + "")
        .setPrice(price)
        .setEventProperties(props || {});
      amplitude.revenue(event);
    } catch (e: any) {
      //console.error(e);
    }
    //    try {
    //      const mixpanel = getMixpanel();
    //      mixpanel.track("sale", { orderId, price });
    //    } catch (e) {
    //      console.error(e);
    //    }
    try {
      const posthog = getPosthog();
      posthog.capture("sale", { orderId, price, ...(props || {}) });
    } catch (e) {
      //console.error(e);
    }
  },
  track: (event: any, props?: Record<string, unknown>) => {
    //    try {
    //      const mixpanel = getMixpanel();
    //      mixpanel.track(event, props);
    //    } catch (e) {
    //      console.error(e);
    //    }
    try {
      const amplitude = getAmplitude();
      amplitude.track(event, props);
    } catch (e) {
      //console.error(e);
    }
    try {
      const posthog = getPosthog();
      posthog.capture(event, props);
    } catch (e) {
      //console.error(e);
    }
  },
  reset() {
    //    try {
    //      const mixpanel = getMixpanel();
    //      mixpanel.reset();
    //    } catch (e) {}
    try {
      Sentry.setUser(null);
    } catch (e) {}
    try {
      const amplitude = getAmplitude();
      amplitude.reset();
    } catch (e) {}
    try {
      const posthog = getPosthog();
      posthog.reset();
    } catch (e) {}
  },
};
